import React,{useEffect, useState} from "react";
import { useRouter } from 'next/router';
import config from "../../config";
import Head from "next/head";
const ThreeDPage = () => {
  const router = useRouter();

  let [city, setPage] = useState({
    delhi:["https://my.matterport.com/show/?m=iwmxD56sodX", 'Orientbell Tiles Boutique New Delhi Virtual 3D Tour', 'Step into the Orientbell Tiles Store in Delhi through immersive 3D technology. Discover the perfect tiles for your home without leaving your couch.'],
    chennai:["https://my.matterport.com/show/?m=8vufRtjZ4Ci", 'Orientbell Tiles Boutique Chennai Virtual 3D Tour', ' Discover a virtual tour of Orientbell Tiles Store in Chennai & experience our range of tiles in captivating 3D. Redefine your space without stepping out of home.'],
    // coimbatore:["https://my.matterport.com/show/?m=jRFGEZJbaGk", 'Orientbell Tiles Boutique Coimbatore Virtual 3D Tour', 'Experience the Orientbell Tiles Store in Coimbatore in stunning 3D from home. Explore our latest collection and imagine your dream space come to life!']
})

let [cityName, setCityName]=useState('')

useEffect(() => {
  if (router.query.city) {
      setCityName(capitalizeFirstLetter(router.query.city));
  }
}, [router.query.city]);
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

return (
<>
{(router.query.city && city[router.query.city] )&&  <>
<Head>
<title>{(city[router.query.city])[1]}</title>
<meta name="title" content={(city[router.query.city])[1]}/>
<meta name="description" content={(city[router.query.city])[2]}/>
</Head>
<div className="container">
  <h1>Orientbell Tile Boutique {cityName}</h1>
<div className="three_d-virtual-city">
    <a href={`${config.HEADLESS_BASE_URL}/3d-virtual-tour-tiles-boutique`}>Go Back</a>
<iframe src={(city[router.query.city])[0]} width="100%" height="515" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
</div>
</div>
</>}
</>
)
}
export default ThreeDPage;